export const FILTER_EVENT = {
  OPENED: '__fe_opened',
  CLOSED: '__fe_closed',
  PRE_COMPUTE: '__fe_pre_compute',
  CHANGED: '__fe_changed',
  CALENDAR_MONTH_CHANGED: '__fe_calendar_month_changed',
  AUTO_SUBMIT: '__fe_auto_submit',
  DISPLAY_VALUE: '__fe_display_value',
};
